import type {
  QueryKey,
  UndefinedInitialDataOptions,
  DefaultError,
} from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

export interface ApiQueryOptions<
  TQueryFnData = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> extends UndefinedInitialDataOptions<
    TQueryFnData,
    DefaultError,
    TData,
    TQueryKey
  > {}

export const useApiQuery = <
  TQueryFnData = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: ApiQueryOptions<TQueryFnData, TData, TQueryKey>,
) => {
  const query = useQuery<TQueryFnData, DefaultError, TData, TQueryKey>({
    ...options,
  });
  return query;
};
